import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const View = { template: '<router-view></router-view>' }

export default new Router({
  routes: [
    //  DASHBOARD

    // Add permission to components using meta
    // meta:{permission:"test"},

    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("./core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: {main_page: true},
          component: () => import("./core/plugins/TitleRibbon/Dashboard")
        },
        {
          path: "/billboard-register",
          name: "billboard register",
          component: () => import("@/view/pages/billboard/register/index"),
          meta: { title: "ثبت بیلبورد" , has_ribbon: true , permission:'billboard_own_list'},
        },
        {
          path: "/billboard-register/create/:id?",
          name: "billboard create",
          component: () => import("@/view/pages/billboard/register/create"),
          meta: { title: "ساخت بیلبورد" , has_ribbon: true , permission:'billboard_create'},
        },
        {
          path: "/billboard-register/:id",
          name: "billboard update",
          component: () => import("@/view/pages/billboard/register/update"),
          meta: { title: "ویرایش بیلبورد" , has_ribbon: true, permission : "billboard_own_update"},
        },
        {
          path: "/billboard-rent",
          name: "billboard rent",
          component: () => import("@/view/pages/billboard/rent/index"),
          meta: { title: "اجاره بیلبورد" , has_ribbon: true, permission : "billboard_accept_list"},
        },

        {
          path: "/billboard-rent/:id",
          name: "billboard rent",
          component: () => import("@/view/pages/billboard/rent/show"),
          meta: { title: "بیلبورد" , has_ribbon: true, permission : "billboard_show"},
          props: true
        },

        {
          path: "/billboard-list",
          name: "billboard rent",
          component: () => import("@/view/pages/admin/billboard/index"),
          meta: { title: "مدیریت بیلبورد ها" , has_ribbon: true, permission : "billboard_list"},
        },

        {
          path: "/billboard-list/:id",
          name: "billboard rent",
          component: () => import("@/view/pages/admin/billboard/update"),
          meta: { title: "مدیریت بیلبورد" , has_ribbon: true, permission : "billboard_update"},
          props:true
        },


        {
          path: "/billboard-list/user/:id",
          name: "billboardUserList",
          component: () => import("@/view/pages/admin/billboard/userList"),
          meta: { title: "بیلبورد های کاربر" , has_ribbon: true, permission : "billboard_list"},
          props:true
        },

        {
          path: "/user-infos",
          name: "user infos",
          component: () => import("@/view/pages/admin/userInfo/index"),
          meta: { title: "مدیریت اطلاعات دریافتی" , has_ribbon: true, permission : "additional_user_info_list"},
        },

        {
          path: "/user-infos/:id",
          name: "user info",
          component: () => import("@/view/pages/admin/userInfo/update"),
          meta: { title: "ویرایش اطلاعات دریافتی" , has_ribbon: true, permission : "show_additional_user_info"},
          props:true
        },

        {
          path: "/billboard-types",
          name: "billboard types",
          component: () => import("@/view/pages/admin/billboardTypes/index"),
          meta: { title: "مدیریت نوع های بیلبورد" , has_ribbon: true, permission : "billboard_type_list"},
        },

        {
          path: "/billboard-types/create",
          name: "billboard type",
          component: () => import("@/view/pages/admin/billboardTypes/create"),
          meta: { title: "ساخت نوع بیلبورد" , has_ribbon: true, permission : "billboard_type_create"},
          props:true
        },
        {
          path: "/billboard-types/:id",
          name: "billboard type",
          component: () => import("@/view/pages/admin/billboardTypes/update"),
          meta: { title: "ویرایش نوع بیلبورد" , has_ribbon: true, permission : "billboard_type_update"},
          props:true
        },

        {
          path: "/admin/billboards",
          name: "admin.billboard",
          component: () => import("@/view/pages/admin/billboard/index"),
          meta: { title: "مدیریت بیلبورد های ثبت شده" , has_ribbon: true, permission : "additional_user_info_list"},
        },

        {
          path: "/table",
          name: "table",
          component: () => import("@/view/pages/table/table-sample.vue")
        },
        {
          path: "/transaction",
          name: "increaseTransactions",
          component: () => import("@/view/pages/transactions/increaseTransactions.vue")
        },
        {
          path: "/panel",
          name: "buyPanel",
          component: () => import("@/view/pages/transactions/buyPanel.vue")
        },


        {
          path: "/permission",
          name: "permission",
          component: () => import("@/view/pages/permission/Index.vue"),
          children:[

            {
              path: 'permission',
              name: 'permission.index',
              component: () => import("@/view/pages/permission/Index.vue"),
              meta: { title: 'دسترسی ها',permission:'permission_access' }
            },


            // {
            //     path: 'create',
            //     name: 'permission.create',
            //     component: () => import('@/view/pages/permission/Create.vue'),
            //     meta: { title: 'cruds.permission.title' }
            // },


            {
              path: 'permission/:id',
              name: 'permission.show',
              component: () => import("@/view/layout/Layout"),
              meta: { title: 'مشاهده ' }
            },


            {
              path: 'permission/:id/edit',
              name: 'permission.edit',
              // component: () => import('@cruds/Permissions/Edit.vue'),
              meta: { title: 'cruds.permission.title' }
            },


          ]
        },

        {
          path: "/admin/user/:id",
          name: "admin.user.edit",
          component: () => import("@/view/pages/admin/users/actions/Edit.vue"),
          meta: { title: "ویرایش کاربر" ,permission: 'user_edit'},
          props: true
        },

        {
          path: "/admin/user-info/:id",
          name: 'admin.users.information',
          component: () => import("@/view/pages/admin/users/actions/Information.vue"),
          meta: { title: "مشاهده اطلاعات کاربر" ,permission: 'user_show'},
          props: true
        },


        {
          path: "/admin/walletEdit/:id",
          name: 'admin.users.walletEdit',
          component: () => import("@/view/pages/admin/users/actions/walletEdit.vue"),
          meta: { title: "ویرایش اطلاعات کیف پول کاربر" ,permission: 'user_show'},
          props: true
        },


        {
          path: "/notifications",
          name: "notifications.index",
          component: () => import("@/view/pages/admin/notifications/Index.vue"),
          meta: { title: 'اعلانات',permission: 'notification_access' }
        },
        {
          path: "/notification/create",
          name: "notification.create",
          component: () => import("@/view/pages/admin/notifications/Create.vue"),
          meta: { title: 'ایجاد اعلان' ,permission: 'notification_create'}
        },
        {
          path: "/notification/:id",
          name: "notification.edit",
          component: () => import("@/view/pages/admin/notifications/Edit.vue"),
          meta: { title: 'ویرایش اعلان' ,permission: 'notification_edit'},
          props:true
        },


        {
          path: "/adminNotifications",
          name: "adminNotifications.index",
          component: () => import("@/view/pages/admin/adminNotifications/Index.vue"),
          meta: { title: 'اعلانات ادمین',permission: 'notification_access' }
        },




        {
          path: "/adminNotifications/:id",
          name: "adminNotifications.edit",
          component: () => import("@/view/pages/admin/notifications/Edit.vue"),
          meta: { title: 'ویرایش اعلان' ,permission: 'notification_edit'},
          props:true
        },



        {
          path: "/tickets",
          name: "tickets.index",
          component: () => import("@/view/pages/tickets/Index.vue"),
          meta: { title: 'تیکت ها' }
        },

        {
          path: "/tickets/create",
          name: "tickets.create",
          component: () => import("@/view/pages/tickets/Create.vue"),
          meta: { title: 'تیکت جدید' }
        },

        {
          path: "/tickets/:id",
          name: "tickets.edit",
          component: () => import("@/view/pages/tickets/Edit.vue"),
          props:true,
          meta: { title: 'ویرایش تیکت'}
        },


        {
          path: "/departments",
          name: "departments.index",
          component: () => import("@/view/pages/admin/departments/Index.vue"),
          meta: { title: 'دپارتمان ها' }
        },

        {
          path: "/departments/create",
          name: "departments.create",
          component: () => import("@/view/pages/admin/departments/Create.vue"),
          meta: { title: 'دپارتمان جدید' }
        },

        {
          path: "/departments/:id",
          name: "departments.edit",
          component: () => import("@/view/pages/admin/departments/Edit.vue"),
          props:true,
          meta: { title: 'ویرایش دپارتمان'}
        },







        {
          path: "/adminTickets",
          name: "adminTickets.index",
          component: () => import("@/view/pages/admin/adminTickets/Index.vue"),
          meta: { title: 'مدیریت تیکت ها' }
        },



        {
          path: "/adminTickets/:id",
          name: "adminTickets.edit",
          component: () => import("@/view/pages/admin/adminTickets/Edit.vue"),
          props:true,
          meta: { title: 'ویرایش تیکت'}
        },















        {
          path: '/payment-callback',
          name: 'paymentCallback',
          component: () => import("@/view/pages/payment-callback/PaymentStatus.vue")
        },
        {
          path: '/pack-properties',
          name: 'pack-properties.index',
          component: () => import("@/view/pages/admin/packProperties/Index.vue"),
          meta: { title: 'ویژگی های بسته' }
        },
        {
          path: '/pack-properties/create',
          name: 'pack-properties.create',
          component: () => import("@/view/pages/admin/packProperties/Create.vue"),
          meta: { title: 'ایجاد ویژگی بسته' }
        },
        {
          path: '/pack-properties/:id',
          name: 'pack-properties.edit',
          component: () => import("@/view/pages/admin/packProperties/Edit.vue"),
          meta: { title: 'ویرایش ویژگی بسته' },
          props: true

        },

        {
          path: '/panels',
          name: 'panels.index',
          component: () => import('@/view/pages/admin/panels/Index.vue'),
          meta: { title: 'پنل ها' ,permission: 'pack_access'}
        },

        {
          path: '/panels/create',
          name: 'panels.create',
          component: () => import('@/view/pages/admin/panels/Create.vue'),
          meta: { title: 'ایجاد پنل',permission: 'pack_create' }
        },

        {
          path: '/panels/:id',
          name: 'panels.edit',
          component: () => import('@/view/pages/admin/panels/Edit.vue'),
          meta: { title: 'ویرایش پنل' ,permission: 'pack_edit'},
          props: true
        },

        {
          path: '/tariff',
          name: 'tariff.index',
          component: () => import('@/view/pages/admin/tariff/Index.vue'),
          meta: { title: 'تعرفه ها' }
        },

        {
          path: '/tariff/create',
          name: 'tariff.create',
          component: () => import('@/view/pages/admin/tariff/Create.vue'),
          meta: { title: 'ایجاد تعرفه' }
        },

        {
          path: '/tariff/:id',
          name: 'tariff.edit',
          component: () => import('@/view/pages/admin/tariff/Edit.vue'),
          meta: { title: 'ویرایش تعرفه' },
          props: true
        },


        {
          path: 'user/confirmed',
          name: 'user.confirmed',
          component: () => import("@/view/pages/admin/confirm/Index.vue"),
          meta: { title: 'درخواست ها ' ,permission: 'user_access'}
        },

        {
          path: 'user/confirmed/:id',
          name: 'user.confirmed.show',
          component: () => import("@/view/pages/admin/confirm/Show.vue"),
          meta: {title: 'مشاهده کاربر',permission: 'user_show'},
          props: true
        },
        {
          path: 'admin/transactions',
          name: 'transactions',
          component: () => import("@/view/pages/admin/transactions/Index.vue"),
          meta: { title: 'مدیریت تراکنش ها' ,permission: 'transaction_access'}
        },
        {
          path: 'admin/transactions/:id',
          name: 'admin.transactions.show',
          component: () => import("@/view/pages/admin/transactions/actions/Information.vue"),
          meta: {title:'مشاهده تراکنش',permission: 'transaction_show'},
          props: true
        },


        {
          path: 'admin/configs',
          name: 'configs',

          component: () => import("@/view/pages/admin/config/Index.vue"),
          meta: { title: 'مدیریت تنظیمات' ,permission: 'config_access'}
        },
        {
          path: 'admin/configs/:id',
          name: 'admin.configs.show',
          component: () => import("@/view/pages/admin/config/Edit.vue"),
          meta: {title:'ویرایش تنظیمات',permission: 'config_show'},
          props: true
        },


        {
          path: 'users',
          name: 'users',
          component: () => import("@/view/pages/admin/users/Index.vue"),
          meta: { title: 'مدیریت کاربران' ,permission:'user_access'}
        },

        {
          path: 'users/:id',
          name: 'users.show',
          component: () => import("@/view/pages/admin/users/Show.vue"),
          meta: {title: 'مشاهده کاربر',permission: 'user_show'},
          props: true
        },

        {
          path: "/category",
          name: "category.index",
          component: () => import("@/view/pages/categories/Index.vue"),
          meta: { title: 'دسته بندی ها' ,permission: 'category_access'}
        },
        {
          path: "/category/create",
          name: "category.create",
          component: () => import("@/view/pages/categories/Create.vue"),
          meta: { title: 'افزودن بندی' ,permission: 'category_create'}
        },
        {
          path: "/category/edit/:id",
          name: "category.edit",
          component: () => import("@/view/pages/categories/Edit.vue"),
          meta: { title: 'ویرایش دسته بندی' ,permission: 'category_edit'},
          props: true
        },

        {
          path: "/content",
          name: "content.index",
          component: () => import("@/view/pages/content/Index.vue"),
          meta: { title: 'محتوا'  ,permission: 'content_access'}
        },
        {
          path: "/content/create",
          name: "content.create",
          component: () => import("@/view/pages/content/Create.vue"),
          meta: { title: 'درج محتوا' ,permission: 'content_create'}
        },
        {
          path: "/content/edit/:id",
          name: "content.edit",
          component: () => import("@/view/pages/content/Edit.vue"),
          meta: { title: 'ویرایش محتوا' ,permission: 'content_edit'},
          props: true
        },
        {
          path: '/role',
          name: 'roles.index',
          component: () => import('@/view/pages/Roles/Index.vue'),
          meta: { title: 'نقش ها' ,permission: 'role_access'}
        },
        {
          path: '/role/edit/:id',
          name: 'role.edit',
          component: () => import('@/view/pages/Roles/Edit.vue'),
          meta: { title: 'ویرایش نقش' ,permission: 'role_edit'},
          props: true
        },
        {
          path: '/role/store',
          name: 'roles.store',
          component: () => import('@/view/pages/Roles/CreateRole.vue'),
          meta: { title: 'افزودن نقش' ,permission: 'role_create'},
        },

        {
          path: '/permission/create',
          name: 'permission.create',
          component: () => import('@/view/pages/permission/Create.vue'),
          meta: { title: 'cruds.permission.title' }
        },
        {
          path: '/permission/edit/:id',
          name: 'permission.edit',
          component: () => import('@/view/pages/permission/Edit.vue'),
          meta: { title: 'cruds.permission.title' ,permission: 'permission_edit'},
          props: true
        },
        {
          path: '/permission/show/:id',
          name: 'permission.show',
          component: () => import('@/view/pages/permission/Show.vue'),
          meta: { title: 'cruds.permission.title' ,permission: 'permission_show' }
        },
        {
          path: '/permission/index',
          name: 'permission.index',
          component: () => import('@/view/pages/permission/Index.vue'),
          meta: { title: 'cruds.permission.title' ,permission: 'paymentGateway_access'}
        },
        {
          path: "/payments",
          name: "payments.index",
          component: () => import("@/view/pages/admin/payment/Index.vue"),
          meta: { title: 'در گاه های پرداخت' ,permission: 'paymentGateway_access'}
        },

        {
          path: "/payment/:id",
          name: "payment.edit",
          component: () => import("@/view/pages/admin/payment/Edit.vue"),
          meta: { title: 'ویرایش در گاه های پرداخت' ,permission: 'paymentGateway_edit' },
          props: true
        },



        {
          path: "/builder",
          name: "builder",
          component: () => import("@/view/pages/Builder.vue")
        },



        {
          path: "/vue-bootstrap",
          name: "vue-bootstrap",
          component: () =>
              import("@/view/pages/vue-bootstrap/VueBootstrap.vue"),
          children: [
            {
              path: "alert",
              name: "vue-bootstrap-alert",
              component: () => import("@/view/pages/vue-bootstrap/Alert.vue")
            },
            {
              path: "badge",
              name: "vue-bootstrap-badge",
              component: () => import("@/view/pages/vue-bootstrap/Badge.vue")
            },
            {
              path: "button",
              name: "vue-bootstrap-button",
              component: () => import("@/view/pages/vue-bootstrap/Button.vue")
            },
            {
              path: "button-group",
              name: "vue-bootstrap-button-group",
              component: () =>
                  import("@/view/pages/vue-bootstrap/ButtonGroup.vue")
            },
            {
              path: "button-toolbar",
              name: "vue-bootstrap-button-toolbar",
              component: () =>
                  import("@/view/pages/vue-bootstrap/ButtonToolbar.vue")
            },
            {
              path: "card",
              name: "vue-bootstrap-card",
              component: () => import("@/view/pages/vue-bootstrap/Card.vue")
            },
            {
              path: "carousel",
              name: "vue-bootstrap-carousel",
              component: () => import("@/view/pages/vue-bootstrap/Carousel.vue")
            },
            {
              path: "collapse",
              name: "vue-bootstrap-collapse",
              component: () => import("@/view/pages/vue-bootstrap/Collapse.vue")
            },
            {
              path: "dropdown",
              name: "vue-bootstrap-dropdown",
              component: () => import("@/view/pages/vue-bootstrap/Dropdown.vue")
            },
            {
              path: "embed",
              name: "vue-bootstrap-embed",
              component: () => import("@/view/pages/vue-bootstrap/Embed.vue")
            },
            {
              path: "form",
              name: "vue-bootstrap-form",
              component: () => import("@/view/pages/vue-bootstrap/Form.vue")
            },
            {
              path: "form-checkbox",
              name: "vue-bootstrap-form-checkbox",
              component: () =>
                  import("@/view/pages/vue-bootstrap/FormCheckbox.vue")
            },
            {
              path: "form-file",
              name: "vue-bootstrap-form-file",
              component: () => import("@/view/pages/vue-bootstrap/FormFile.vue")
            },
            {
              path: "form-group",
              name: "vue-bootstrap-form-group",
              component: () =>
                  import("@/view/pages/vue-bootstrap/FormGroup.vue")
            },
            {
              path: "form-input",
              name: "vue-bootstrap-form-input",
              component: () =>
                  import("@/view/pages/vue-bootstrap/FormInput.vue")
            },
            {
              path: "form-radio",
              name: "vue-bootstrap-form-radio",
              component: () =>
                  import("@/view/pages/vue-bootstrap/FormRadio.vue")
            },
            {
              path: "form-select",
              name: "vue-bootstrap-form-select",
              component: () =>
                  import("@/view/pages/vue-bootstrap/FormSelect.vue")
            },
            {
              path: "form-textarea",
              name: "vue-bootstrap-form-textarea",
              component: () =>
                  import("@/view/pages/vue-bootstrap/FormTextarea.vue")
            },
            {
              path: "image",
              name: "vue-bootstrap-image",
              component: () => import("@/view/pages/vue-bootstrap/Image.vue")
            },
            {
              path: "input-group",
              name: "vue-bootstrap-input-group",
              component: () =>
                  import("@/view/pages/vue-bootstrap/InputGroup.vue")
            },
            {
              path: "jumbotron",
              name: "vue-bootstrap-jumbotron",
              component: () =>
                  import("@/view/pages/vue-bootstrap/Jumbotron.vue")
            },
            {
              path: "layout-grid-system",
              name: "vue-bootstrap-layout-grid-system",
              component: () =>
                  import("@/view/pages/vue-bootstrap/LayoutGridSystem.vue")
            },
            {
              path: "link",
              name: "vue-bootstrap-link",
              component: () => import("@/view/pages/vue-bootstrap/Link.vue")
            },
            {
              path: "list-group",
              name: "vue-bootstrap-list-group",
              component: () =>
                  import("@/view/pages/vue-bootstrap/ListGroup.vue")
            },
            {
              path: "media",
              name: "vue-bootstrap-media",
              component: () => import("@/view/pages/vue-bootstrap/Media.vue")
            },
            {
              path: "modal",
              name: "vue-bootstrap-modal",
              component: () => import("@/view/pages/vue-bootstrap/Modal.vue")
            },
            {
              path: "nav",
              name: "vue-bootstrap-nav",
              component: () => import("@/view/pages/vue-bootstrap/Nav.vue")
            },
            {
              path: "navbar",
              name: "vue-bootstrap-navbar",
              component: () => import("@/view/pages/vue-bootstrap/Navbar.vue")
            },
            {
              path: "pagination",
              name: "vue-bootstrap-pagination",
              component: () =>
                  import("@/view/pages/vue-bootstrap/Pagination.vue")
            },
            {
              path: "pagination-nav",
              name: "vue-bootstrap-pagination-nav",
              component: () =>
                  import("@/view/pages/vue-bootstrap/PaginationNav.vue")
            },
            {
              path: "notify-popover",
              name: "vue-bootstrap-popover",
              component: () => import("@/view/pages/vue-bootstrap/Popover.vue")
            },
            {
              path: "notify-toasts",
              name: "vue-bootstrap-toasts",
              component: () => import("@/view/pages/vue-bootstrap/Toasts.vue")
            },
            {
              path: "notify-tooltip",
              name: "vue-bootstrap-tooltip",
              component: () => import("@/view/pages/vue-bootstrap/Tooltip.vue")
            },
            {
              path: "progress",
              name: "vue-bootstrap-progress",
              component: () => import("@/view/pages/vue-bootstrap/Progress.vue")
            },
            {
              path: "progress-spinner",
              name: "vue-bootstrap-spinner",
              component: () => import("@/view/pages/vue-bootstrap/Spinner.vue")
            },
            {
              path: "table",
              name: "vue-bootstrap-table",
              component: () => import("@/view/pages/vue-bootstrap/Table.vue")
            },
            {
              path: "tabs",
              name: "vue-bootstrap-tabs",
              component: () => import("@/view/pages/vue-bootstrap/Tabs.vue")
            }
          ]
        },
        {
          path: "/custom-wizard",
          name: "wizard",
          component: () => import("@/view/pages/wizard/Wizard.vue"),
          children: [
            {
              path: "wizard-1",
              name: "wizard-1",
              component: () => import("@/view/pages/wizard/Wizard-1.vue")
            },
            {
              path: "wizard-2",
              name: "wizard-2",
              component: () => import("@/view/pages/wizard/Wizard-2.vue")
            },
            {
              path: "wizard-3",
              name: "wizard-3",
              component: () => import("@/view/pages/wizard/Wizard-3.vue")
            },
            {
              path: "wizard-4",
              name: "wizard-4",
              component: () => import("@/view/pages/wizard/Wizard-4.vue")
            }
          ]
        },
        {
          path: "/custom-plugins",
          name: "plugins",
          component: () => import("@/view/pages/plugins/Plugins.vue"),
          children: [
            {
              path: "cropper",
              name: "cropper",
              component: () => import("@/view/pages/plugins/Cropper.vue")
            },
            {
              path: "treeselect",
              name: "treeselect",
              component: () => import("@/view/pages/plugins/Treeselect.vue")
            }
          ]
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/profile/Profile.vue"),
          children: [
            {
              path: "my-profile",
              name: "myProfile",
              component: () => import("@/view/pages/profile/MyProfile.vue")
            },
            {
              path: "profile-2",
              name: "profile-2",
              component: () => import("@/view/pages/profile/Profile-2.vue")
            },
            {
              path: "profile-3",
              name: "profile-3",
              component: () => import("@/view/pages/profile/Profile-3.vue")
            },
            {
              path: "profile-4",
              name: "profile-4",
              component: () => import("@/view/pages/profile/Profile-4.vue")
            }
          ]
        },
        //bilboard
        {
          path: "/company-register",
          name: "company-register",
          component: () => import("@/view/pages/bilboard/CompanyRegister.vue"),
          meta: {title: "پروفایل من" ,  has_ribbon:true}
        }
      ]
    },

    //  ERRORS
    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue")
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue")
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue")
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue")
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue")
        }
      ]
    },

    //  LOGIN REGISTER
    {
      path: "/",
      component: () => import("@/view/pages/auth/login"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/login")
        },

        {
          name: "test",
          path: "/test",
          component: () => import("@/view/pages/auth/login")
        },
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/login_pages/Login-1")
        }
      ]
    },

    {
      path:"/keke:acees_token",
      component: () => import("@/view/pages/auth/login"),
    },
    //  404
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
